// extracted by mini-css-extract-plugin
export var errorBanner = "_c4-2";
export var scroller = "_c4-0";
export var thinking = "_c4-1";
export var visuallyHidden = "_c4-3";